import { Injectable } from '@angular/core';
import { surveyCod } from 'src/environments';

@Injectable({
  providedIn: 'root',
})
export class MedalliaService {
  constructor() {}

  startSurvey(keySurvey: string) {
    const idSurvey = surveyCod[keySurvey];
    window.Titulo_enc_med = 'FB_Agendamiento Web S.público';
    window.KAMPYLE_ONSITE_SDK.showForm(idSurvey);
  }
}
